export default __webpack_public_path__ + "static/media/soma.b0b5864e.jpg";